export const viewModeEnum = {
    ICON: 1,
    DETAILS: 2,
};

export const itemTypeEnum = {
    GROUP: 1,
    LINK: 2,
    VIDEO: 3,
    SKILL_PATH: 5
};